import React, { useId } from 'react';

// Marchio Sonitech: la "S" tagliata in diagonale (bianco + blu) su tile brand,
// costante in ogni tema/modo. Ids unici per istanza (clipPath non collidono).
const S_PATH = 'M30 18.6 C30 16 27.6 15 24 15 C20.4 15 18 16.2 18 18.6 C18 21 20.4 22 24 23 C27.6 24 30 25 30 27.4 C30 29.8 27.6 31 24 31 C20.4 31 18 29.8 18 27.4';

export default function Logo({ size = 26, className = '' }) {
  const uid = useId().replace(/[:]/g, '');
  const top = `t${uid}`;
  const bot = `b${uid}`;
  return (
    <svg className={`mk ${className}`} width={size} height={size} viewBox="0 0 48 48" aria-label="Sonitech">
      <rect x="2" y="2" width="44" height="44" rx="12" fill="#0C2036" />
      <clipPath id={top}><polygon points="2,2 52,2 2,52" /></clipPath>
      <clipPath id={bot}><polygon points="52,2 52,52 2,52" /></clipPath>
      <g clipPath={`url(#${top})`}>
        <g transform="translate(-7.2,-6.9) scale(1.3)">
          <path d={S_PATH} fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" />
        </g>
      </g>
      <g clipPath={`url(#${bot})`}>
        <g transform="translate(-7.2,-6.9) scale(1.3)">
          <path d={S_PATH} fill="none" stroke="#3BA9E0" strokeWidth="2.6" strokeLinecap="round" />
        </g>
      </g>
    </svg>
  );
}
